export default "__VITE_ASSET__DM_HaFXS__"